import { render, staticRenderFns } from "./EditInvoiceBatch.vue?vue&type=template&id=687df43f"
import script from "./EditInvoiceBatch.vue?vue&type=script&lang=ts"
export * from "./EditInvoiceBatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports